export function getdata() {
	let obj = {


		searchlist: [{
				prop: "version",
				label: '版本号',
				type: "input"
			},
			{
				prop: "versionShuom",
				label: '说明',
				type: "input"
			},
			{
				prop: "queryTime",
				label: '版本启用期间',
				type: "date"
			},
		],
		searchdata: {
			version: "",
			versionShuom: "",
			queryTime: [],
		},
		headData: [{
				title: "版本号",
				prop: "version",
				custom: true,
				width: 80
			},
			{
				title: "说明",
				prop: "versionShuom",
				custom: true,
				width: 160,
			},
			{
				title: "版本启用期间",
				prop: "queryTime",
				custom: true,
				width: 160,
			},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				width: "150px"

			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},

	}
	return obj
}
